<template>
	<el-row>
		<el-row type="flex" class="row-bg" justify="space-between">
			<filter-panel class="filter-panel" :data="swarchGroups" @search="filterChange" :simple="true">
			</filter-panel>
		</el-row>
		<el-col :span="24" class="google-list">
			<data-list
				style="margin-top: 10px;"
				:page="page"
				:table-style="{ name: 'mixture' }"
				:data="data"
				:columns="columns"
				:loading="loading"
				@page-size-changed="pageSizeChanged"
				@page-changed="pageChanged"
				@sort-change="sortChange"
			></data-list>
		</el-col>
	</el-row>
</template>

<script>
import customer from '@/mixins/customer';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
//获取新用户上线方案列表的数据
const page = listPageCreate({
	searchConfig: {
		api: api.googleAds.list,
		method: 'POST',
	},
});
export default {
	name: 'newUserOnline',
	components: {
		filterPanel,
	},
	mixins: [customer, page],
	data() {
		let _this = this;
		return {
			filterParams: null,
			searchNum: '',
			addDiaVisible: false,
			columns: [
				{
					label: '客户名称',
					bind: 'customerName',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '服务单号',
					//width: 250,
					bind: 'serviceCode',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: 'CID',
					bind: 'cid',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '状态',
					bind: 'status',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '确认人',
					bind: 'createName',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '优化师',
					bind: 'serviceStaffName',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '确认时间',
					bind: 'createTime',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					width: 150,
					bind(val) {
						if (val.status === '拓词完成') {
							return [
								{
									text: '查看详情',
									trigger(row) {
										_this.$router.push({
											name: 'detailsAboutNewUser',
											query: {
												serviceId: row.serviceId,
											},
										});
									},
								},
							];
						} else {
							return [
								{
									text: '-',
								},
							];
						}
					},
				},
			],
			swarchGroups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '查询服务单',
						prop: 'serviceCode',
						clearable: true,
						value: '',
					},
					{
						tagName: 'sky-input',
						placeholder: '查询CID',
						prop: 'cid',
						clearable: true,
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '选择状态',
						prop: 'status',
						props: {
							label: 'name',
							value: 'id',
						},
						value: '',
						options: [
							{ id: 1, name: '核心产品词推荐列表生成中' },
							{ id: 2, name: '方案待确认' },
							{ id: 3, name: '方案已确认，自动扩词中' },
							{ id: 4, name: '拓词完成' },
							{ id: 5, name: '网站待上线' },
						],
					},
					{
						tagName: 'sky-input',
						placeholder: '查询优化师',
						prop: 'serviceStaffName',
						props: {
							label: 'name',
							value: 'id',
						},
						value: '',
						options: [],
					},
				],
			},
		};
	},
	methods: {
		requestData() {
			this.query();
		},
		//移除黑名单
	},
	mounted() {
		this.requestData();
	},
};
</script>

<style scoped lang="scss"></style>
